import { CONTENT_GROUP_ACTION, CONTENT_GROUP_CALENDAR } from "../constants";

const initialState = {
    calendarCards: [],
    shouldCloseOverLay: false,
};

const removeKeys = (object) => {
    const { assigned_users, preview, first_record, ...rest } = object;

    return rest;
}

export function calendar(state = initialState, action) {
    switch (action.type) {
        case CONTENT_GROUP_CALENDAR.SET_CALENDAR_CARDS: {
            return {
                ...state,
                calendarCards: action.payload,
            };
        }
        case CONTENT_GROUP_CALENDAR.UPDATE_CALENDAR_CARD_DRAFT_STATUS: {
            const { stage_id, content_group_id, partner_draft, internal_draft } = action.payload;

            const updatedArray = state.calendarCards.map((existingCard) => {
                if (existingCard.id === content_group_id) {
                    return {
                        ...existingCard,
                        drafts: [partner_draft, internal_draft],
                    };
                }
                return existingCard;
            });

            return {
                ...state,
                calendarCards: updatedArray,
            };
        }

        case CONTENT_GROUP_CALENDAR.ADD_CALENDAR_CARDS: {
            const cards = action.payload;
            const new_card_ids = cards.map((s) => s.id);
            const old_cards = state.calendarCards.filter((s) => !new_card_ids.includes(s.id));
            const new_cards = [...old_cards, ...cards];

            const old_array = old_cards.map(removeKeys);
            const new_array = new_cards.map(removeKeys);

            const hasChanged = JSON.stringify(old_array) !== JSON.stringify(new_array);

            return {
                ...state,
                calendarCards: [
                                ...state.calendarCards.filter(card => !cards.find(c => c.id === card.id)), 
                                ...cards
                               ],
                shouldCloseOverLay: hasChanged,
            };
        }

        case CONTENT_GROUP_CALENDAR.UPDATE_CALENDAR_CARD: {
            const updatedCard = action.payload;

            const updatedArray = state.calendarCards.map((existingCard) => {
                if (existingCard.id === updatedCard.id) {
                    return {
                        ...existingCard,
                        ...updatedCard,
                    };
                }
                return existingCard;
            });

            return {
                ...state,
                calendarCards: updatedArray,
            };
        }

        case CONTENT_GROUP_CALENDAR.REMOVE_CALENDAR_CARD: {
            const card = action.payload;
            const old_array = state.calendarCards.map(removeKeys);
            const new_array = state.calendarCards.filter(c => c.id !== card.id)
                                                 .map(removeKeys);

            const hasChanged = JSON.stringify(old_array) !== JSON.stringify(new_array);
            
            return {
                ...state,
                calendarCards: new_array,
                shouldCloseOverLay: hasChanged,
            };
        }

        case CONTENT_GROUP_CALENDAR.CLEAR_SHOULD_CLOSE_OVERLAY: {
            return {
                ...state,
                shouldCloseOverLay: false,
            };
        }

        case CONTENT_GROUP_ACTION.ADD_LABEL_TO_CARD: {
            const { card, label } = action.payload;
            
            const updatedArray = state.calendarCards.map((existingCard) => {
                if (existingCard.id === card.id) {
                    return {
                        ...existingCard,
                        labels: [
                                    ...existingCard.labels.filter(l => l.id !== label.id), 
                                    label
                                ],
                    };
                }
                return existingCard;
            });

            return {
                ...state,
                calendarCards: updatedArray,
            };
        }

        case CONTENT_GROUP_ACTION.REMOVE_LABEL_FROM_CARD: {
            const { card, label } = action.payload;
            
            const updatedArray = state.calendarCards.map((existingCard) => {
                if (existingCard.id === card.id) {
                    return {
                        ...existingCard,
                        labels: existingCard.labels.filter(l => l.id !== label.id)
                    };
                }
                return existingCard;
            });

            return {
                ...state,
                calendarCards: updatedArray,
            };
        }

        case CONTENT_GROUP_ACTION.UPDATE_CARD_UNREAD_COMMENTS: {
            const card = action.payload;

            // Find the stage containing the card and update its labels
            const updatedArray = state.calendarCards.map((existingCard) => {
                if (existingCard.id === card.id) {
                    return {
                        ...existingCard,
                        unread_comments: card.unread_comments
                    };
                }
                return existingCard;
            });

            return {
                ...state,
                calendarCards: updatedArray
            }
        }
        default:
            return state;
    }
}